import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Home, PawPrint } from 'lucide-react';
import { Dropdown } from './Dropdown';

interface AdoptionDropdownProps {
  location: {
    pathname: string;
  };
}

export function AdoptionDropdown({ location }: AdoptionDropdownProps) {
  const isActive = ['/zwierzeta', '/adoptuj', '/wirtualna-adopcja'].includes(location.pathname);

  return (
    <Dropdown 
      title={
        <div className="flex items-center gap-2">
          <span>Adopcja</span>
        </div>
      }
      isActive={isActive}
    >
      <div className="py-2 min-w-[220px]">
        <Link 
          to="/zwierzeta"
          className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
        >
          <PawPrint className="w-4 h-4 text-accessible-red-600" />
          <span>Zwierzęta do adopcji</span>
        </Link>
        <Link 
          to="/adoptuj" 
          className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
        >
          <Home className="w-4 h-4 text-accessible-red-600" />
          <span>Adoptuj</span>
        </Link>
        <Link 
          to="/wirtualna-adopcja" 
          className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
        >
          <Heart className="w-4 h-4 text-accessible-red-600" />
          <span>Adopcja wirtualna</span>
        </Link>
        <Link 
          to="/historie-adopcyjne" 
          className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
        >
          <span>Historie adopcyjne</span>
        </Link>
        <Link 
          to="/za-teczowym-mostem" 
          className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2"
        >
          <span>Za tęczowym mostem</span>
        </Link>
      </div>
    </Dropdown>
  );
}